// extracted by css-extract-rspack-plugin
export default {"company-worker-select":"company-worker-select-julHwS","companyWorkerSelect":"company-worker-select-julHwS"};